import React, { useCallback, useEffect, useState } from "react";
import { TableComponents, TableVirtuoso } from "react-virtuoso";
import Api from "Api";

import {
  CircularProgress,
  Paper,
  Stack,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import QueryData from "Constants/QueryData";
import { useAppSelector } from "Hooks/useRedux";

export const StyledTableRow = styled(TableRow)(() => ({}));
export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#E1E1E1",
    color: "#000000",
    fontWeight: "500",
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
  },
}));

interface IProps {
  headerColumns: any[];
  isLoading?: boolean;
  data?: any[];
  rowContent?: any;
}

const VirtuosoTableComponents: TableComponents<any> = {
  Scroller: React.forwardRef<HTMLDivElement>((props, ref) => <TableContainer {...props} ref={ref} />),
  Table: (props) => <MuiTable {...props} sx={{ tableLayout: "fixed" }} />,
  TableHead,
  TableRow: ({ ...props }) => <StyledTableRow {...props} />,
  TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => <TableBody {...props} ref={ref} />),
};

export default function Table({ headerColumns, isLoading, data, rowContent }: IProps) {
  const [tableData, setTableData] = useState<any[]>([]);

  const headerContent = () => {
    return (
      <TableRow>
        {headerColumns.map((column) => (
          <StyledTableCell style={column.style}>{column.title}</StyledTableCell>
        ))}
      </TableRow>
    );
  };

  //

  const { status } = useAppSelector((state) => state.menu);
  const { visible } = useAppSelector((state) => state.surveys);
  const { source, destination, autoApply, applySelecteds, forceUpdate, zone } = useAppSelector((state) => state.zones);
  const { conformity, surveys } = useAppSelector((state) => state.filters);
  const { center, moveEnd } = useAppSelector((state) => state.map);

  const filterQueries = () => {
    let result = "";
    Object.keys(surveys).forEach((i) => {
      const value = surveys[i as keyof typeof surveys];
      if (value !== "" && i !== "working_days") result += `&${i}=${value}`;
    });
    return result;
  };
  const workingDaysQuery = () => {
    if (!surveys.working_days) return "";

    let result = "";
    surveys.working_days.forEach((i: number) => {
      result += `&working_days[]=${i}`;
    });
    return result;
  };
  const conformityQuery = () => {
    return `${conformity.source ? "&contain[]=sources" : ""}${conformity.destination ? "&contain[]=destinations" : ""}`;
  };
  const zonesQuery = () => {
    if (source.length === 0 && destination.length === 0) {
      return `&center_lat=${center.lat}&center_lng=${center.lng}&radius=1`;
    }
    return `${source.length > 0 ? `&${source.map((i) => `source_zones[]=${i}`).join("&")}` : ""}${
      destination.length > 0 ? `&${destination.map((i) => `destination_zones[]=${i}`).join("&")}` : ""
    }`;
  };

  const handleQueryKeys = () => {
    if (autoApply) {
      return [QueryData.SURVEY.key, conformity, source, destination, moveEnd];
    }
    return [QueryData.SURVEY.key, conformity, forceUpdate, moveEnd];
  };
  //

  const loadMore = useCallback(() => {
    return setTimeout(() => {
      Api.get(
        `survey?pageLength=100&page=${
          Math.floor(tableData.length / 100) + 1
        }${conformityQuery()}${zonesQuery()}${filterQueries()}${workingDaysQuery()}`
      ).then((res) => {
        setTableData((perv) => {
          return [...perv, ...res.data.Data.data];
        });
      });
    }, 200);
  }, [setTableData, conformity, forceUpdate, moveEnd]);

  useEffect(() => {
    const timeout = loadMore();
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Paper style={{ height: data ? "100%" : "auto", width: "100%", borderRadius: 5, overflow: "hidden" }} elevation={0}>
      {isLoading && (
        <Stack alignItems="center" mt={3}>
          <CircularProgress />
        </Stack>
      )}

      {data?.length === 0 ? (
        <Typography align="center" py={3} variant="h6">
          داده ای موجود نیست
        </Typography>
      ) : (
        <TableVirtuoso
          // data={tableData}
          data={data}
          // endReached={loadMore}
          components={VirtuosoTableComponents}
          fixedHeaderContent={headerContent}
          itemContent={rowContent}
        />
      )}
    </Paper>
  );
}
